// extracted by mini-css-extract-plugin
export default {"heading":"Jw-z","corrected":"Kw-z","redirectVerbiageContainer":"Lw-z","redirectVerbiageText":"Mw-z"};